import React from 'react';

const boxStyles = {
    borderWidth: 1,
    borderStyle: 'dashed',
    borderRadius: 4,
    padding: '10px 12px',
    marginBottom: '10px',
    display: 'block',
};

const severityStyles = {
    info: { borderColor: '#1976d2', backgroundColor: 'rgba(25,118,210,0.04)' },
    warning: { borderColor: '#ffa000', backgroundColor: 'rgba(255,160,0,0.04)' },
    error: { borderColor: '#d32f2f', backgroundColor: 'rgba(211,47,47,0.04)' },
    success: { borderColor: '#2e7d32', backgroundColor: 'rgba(46,125,50,0.04)' },
};

export default function HighlightBox({ children, severity = 'info', className = '', style = {}, ...rest }) {
    return (
        <div
            className={className || undefined}
            style={{ ...boxStyles, ...(severityStyles[severity] || severityStyles.info), ...style }}
            {...rest}>
            {children}
        </div>
    );
}
